import app from 'app';
import LZString from 'lz-string';

import lineClamp from 'components/line-clamp';

import backToTop from './collection/back-to-top';
import filter from './collection/filter';
import filterShortcut from './collection/filter-shortcut';
import grid from './collection/grid';
import gridView from './collection/grid-view';
import gridViewValue from './collection/grid-view-value';
import main from './collection/main';
import collectionPagination from './collection/pagination';

// Collection state

const getCachedData = () => {
  const key = `SNT_COLLECTION:${window.theme.collectionHandle}`;

  try {
    const { products = [], pagination = null } = JSON.parse(
      LZString.decompress(sessionStorage.getItem(key)) || '{}',
    );
    if (window.location.search.includes('page=')) {
      return { cachedProducts: products, cachedPagination: pagination };
    }

    return { cachedProducts: [], cachedPagination: null };
  } catch {
    return [];
  }
};

// Fill with initial data (like pagination data)
app.hydrate({
  activeFilters: [],
  filterData: {},
  pagination: {},
  columns: 2,
  openDrawers: [],
  ...getCachedData(),
});


app.add({
  main,
  'collection-filter': filter,
  'collection-grid': grid,
  'collection-pagination': collectionPagination,
  'collection-back-to-top': backToTop,
  'collection-filter-shortcut': filterShortcut,
  'collection-grid-view': gridView,
  'collection-grid-view-value': gridViewValue,
  'line-clamp': lineClamp,
});
